///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { useState } from "react";
import { useHistory } from "react-router";

import Modal from "../../Modal";
import messages from "../../../helpers/messages";
import { FormattedMessage } from "react-intl";
import { deleteBid } from "../../../api/bids";
import Spinner from "../../icons/Spinner";
import SystemErrorModal from "../../SystemErrorModal";

export const DeleteBidModal = ({
  open,
  handleClose,
  bidName,
  bidId
}) => {
  const [isFetching, setIsFetching] = useState(false);
  const [isFailed, setIsFailed] = useState(false);
  const history = useHistory();

  const handleDelete = () => {
    setIsFetching(true);
    setIsFailed(false);

    deleteBid(bidId)
      .then(() => {
        setIsFetching(false);
        history.replace("");
      })
      .catch(() => {
        setIsFetching(false);
        setIsFailed(true);
      });
  };
  return (
    <>
      <SystemErrorModal
        open={open && isFailed}
        closeModal={handleClose}
        handleExit={handleClose}
        handleTryAgain={handleDelete}
      />
      <Modal
        title={messages.warning.defaultMessage}
        open={open && !isFailed}
        handleClose={handleClose}
        titleClass="modal__title_light uppercase"
        bodyClass="border-top-grey px-24 pt-24"
        closeButtonClass="modal__close-button mr-16 mt-16"
        large={true}
      >
        <p
          data-testid="delete-bid-message"
          className="font-size-16 text-dim-grey pb-8"
        >
          <FormattedMessage
            {...messages.deleteBidConfirmationMessage}
            values={{ bidName }}
          />
        </p>
        <div className="grid fr mb-24">
          <div className="grid__cell pr-8">
            <button
              data-testid="cancel-button"
              className="secondary-button one-whole cursor-pointer univers-67-bold-cond"
              onClick={handleClose}
            >
              {messages.cancel.defaultMessage}
            </button>
          </div>
          <div className="grid__cell pl-8">
            <button
              data-testid="delete-button"
              className="text-button delete-button one-whole cursor-pointer univers-67-bold-cond"
              onClick={handleDelete}
            >
              {isFetching ? (
                <Spinner
                  className="spinner"
                  height="16px"
                  width="16px"
                  fill="#ff572b"
                />
              ) : (
                messages.delete.defaultMessage
              )}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DeleteBidModal;
